module.exports = __webpack_public_path__ + "static/media/no-search.9ce4a54c.png";